import React, { useEffect, useState } from "react";
import { ModalInputs } from "@empreinte/components.modal-inputs";
import { useTranslation } from "react-i18next";
import Hooks from "../utils/hooks";
import { Chip, TextField, ListItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAppSelector } from "../../redux/hooks";
import { PostData } from "../../APIcalls";
import "./ModalInputs.scss";
import toast from "react-simple-toasts";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import validator from 'validator';

function ShowEmailModal({ idVideo, video }) {
	const { t } = useTranslation();
	const { handleCancel } = Hooks();
	const modalToOpen = useAppSelector((state) => state.MediaReducer.modalToOpen);
	const [email, setEmail] = useState("");
	const [chipData, setChipData] = React.useState([]);
	const [btnDisabled, setBtnDisabled] = useState(true);
	const [error, setError] = useState(false);
	const [errorMsg, setErrorMsg] = useState("");
	const [errorTimer, setErrorTimer] = useState(null);
	const [alertMsg, setAlertmsg] = useState("");
	const [loader, setLoader] = useState(false);
	const userData = useSelector((state) => state.ReducerUserData.userData);


	const validateEmail = (email) => {
		if (!email) {
			setError(false);
			return true;
		} else {
			setError(!validator.isEmail(email));
			setErrorMsg(!validator.isEmail(email) ? `${t("Profile.invalid-Email")}` : "");
			return validator.isEmail(email);
		}
	};
	const handleDelete = (emailToDelete) => {
		setChipData((chips) => chips.filter((chip) => chip !== emailToDelete));
	};
	const handleEnterKeyPress = (e) => {
		e.preventDefault();
		if (e.code === "Enter" && email.trim() !== "") {
			let index = 0;
			if (validateEmail(email.trim()) === true) {
				const newChip = {
					key: index++,
					label: email.trim(),
				};
        setBtnDisabled(false)
				setErrorTimer(null);
				if (!chipData.some((chip) => chip.label === newChip.label)) {
					setChipData((chips) => [...chips, newChip]);
					setEmail("");
					setError(false);
				} else {
					setError(true);
					setErrorMsg(`${t("Profile.duplicated-Email")}`);
				}
			}
		}
	};
	const reset = () => {
		setEmail("");
		setError(false);
		setChipData([]);
		handleCancel();
		setErrorTimer(null);
		setLoader(false);
	};

	const sendEmail = async () => {
		setLoader(true);
		const data = {
			video_id: idVideo,
			nom: userData.lastName, 
			prenom: userData.firstName, 
			emails: chipData.map((item) => `${item.label}`),
		};
		await PostData("/video-api/video/emails-download-video", data)
			.then((res) => {
				if (+res?.status === 200) {
					toast(t("Profile.sent-link-success"), {
						position: "top-center",
						className: "successToast",
					});
					reset();
				}
			})
			.catch((err) =>{
				toast(t("Profile.send-link-error"), { position: "top-center", className: "errorToast" });
        		reset();
			}
			);
	};

	useEffect(() => {
		if (email && error === false && errorTimer === null && chipData.length === 0) {
			const timer = setTimeout(() => {
				setAlertmsg(`${t("Profile.Msg-reminder")}`);
			}, 3000); // 3 seconds

			setErrorTimer(timer);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modalToOpen, video, error, errorTimer, email]);
	return (
		<ModalInputs
			open={modalToOpen === "showEmailModal"}
			onClose={handleCancel}
			title={t("Profile.send-Emails")}
			onCancel={handleCancel}
			onConfirm={()=>chipData.length > 0 ? sendEmail() : setBtnDisabled(true)}
			ConfirmBtnName={t("Profile.send")}
			CancelBtnName={t("Profile.cancel")}
			disabled={(!email && !chipData.length) || btnDisabled ? true : false}
		>
			{loader ? (
				<div className="Loading-container">
					<CircularProgress />
				</div>
			) : (
				<div className="Email-container">
					<span>{t("Profile.Email-title")}</span>
					<div className="chip_container">
						{chipData.map((data) => (
							<ListItem key={data.key} style={{ width: "auto" }}>
								<Chip
									label={data.label}
									onDelete={() => handleDelete(data)}
									className="chipItem"
									deleteIcon={<CloseIcon style={{ fontSize: 14, color: "#62626B" }} />}
								/>
							</ListItem>
						))}
					</div>
					<TextField
						id="standard-multiline-static"
						error={error}
						helperText={errorMsg}
						className="inputField"
						variant="standard"
						fullWidth={true}
						placeholder={t("Profile.input-email-placeholder")}
						value={email}
						onChange={(e) => {
							if (!e.target.value) {
								setError(false);
								setErrorMsg("");
								setErrorTimer(null);
							} else {
								validateEmail(e.target.value);
							}
							setEmail(e.target.value);
						}}
						onKeyUp={handleEnterKeyPress}
					/>
					{errorTimer && (
						<small style={{ color: "gray", fontSize: "12px", paddingLeft: "10px" }}>
							{alertMsg}
						</small>
					)}
				</div>
			)}
		</ModalInputs>
	);
}
export default ShowEmailModal;